import type { LooseObject } from '@piccolohealth/util';
import React from 'react';
import { CommandActionsPageContent } from './CommandActionsPageContent';
import { CommandFreePageContent } from './CommandFreePageContent';
import type { CommandMenuContext, Page } from './CommandMenu';
import { CommandTabbedPageContent } from './CommandTabbedPageContent';

interface Props<A> {
  page: Page<A>;
  context: CommandMenuContext<A>;
  args?: LooseObject;
}

export const CommandPageContent = <A,>(props: Props<A>) => {
  const { page, context, args } = props;

  switch (page.kind) {
    case 'free':
      return <CommandFreePageContent page={page} context={context} args={args} />;
    case 'actions':
      return <CommandActionsPageContent page={page} context={context} />;
    case 'tabbed':
      return <CommandTabbedPageContent page={page} context={context} />;
  }
};
